module.exports = __webpack_public_path__ + "static/media/Take the tour crank this baby up.e82433af.mp4";